export default "__VITE_ASSET__7033828a__"